module.exports = __webpack_public_path__ + "static/media/DM.d3c5033e.svg";